export default "__VITE_ASSET__DRjwQp6R__"